export default ['JsonRPCService', JsonRPCService => {
    return {
        getPropertyCodes: (lob, jobNumber, previousClassCode, address, sessionUUID) => {
            return JsonRPCService.send('propertycode', 'propertycode', 'getPropertyCodes', [lob, jobNumber, previousClassCode, address, sessionUUID]);
        }
    };
}
];
